export const initialState = {
  loading: false,
  error: "",
  currentDate: "",

  data: [],
  Organization: [],
  realTimeLineActivityData: [],
  realTimeLineActivityNonSeed: [],

  realTimeWarehouseActivity: [],
  realTimeWarehouseLine: [],
  realTimeWarehouseCount: [],

  drierStatusReport: [],
  drierStatusReportEven: [],
  drierStatusReportOdd: [],
  DryingTransactionTemp: [],

  warehouseStatusData: [],
  seedLines: [],
  nonSeedLines: [],
};
